<template>
  <v-row no-gutters>
    <v-col>
      <AdminInputStockStepper
        ref="field"
        v-model="number"
        v-on="$listeners"
        v-bind="{ ...$attrs, ...$props }"
        @update:delta="delta = $event"
      />
    </v-col>
    <v-col>
      <div v-if="!!delta" class="mt-1 text-h6"
        >Change of {{ deltaWithSign }}</div
      >
    </v-col>
  </v-row>
</template>

<script>
import AdminInputStockStepper from '@/components/AdminInputStockStepper'
export default {
  name: 'AdminFieldStockStepper',
  components: { AdminInputStockStepper },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      number: this.value,
      delta: 0,
    }
  },
  created() {
    this.number = this.value
  },
  computed: {
    numberAsInt() {
      return parseInt(this.number, 10)
    }, // numberAsInt
    rules() {
      let rules = []
      if (this.min) {
        rules.push(
          (v) =>
            Number(v) >= Number(this.min) ||
            `Enter a number greater than ${this.min}`
        )
      }
      if (this.max) {
        rules.push(
          (v) =>
            Number(v) <= Number(this.max) ||
            `Enter a number less than ${this.max}`
        )
      }
      return rules
    },
    deltaWithSign() {
      return (this.delta < 0 ? '' : '+') + this.delta
    }, // deltaWithSign
  },
}
</script>
